import { render, staticRenderFns } from "./complex.vue?vue&type=template&id=36986a7f&"
import script from "./complex.vue?vue&type=script&lang=js&"
export * from "./complex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports